var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
var Hr = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  border: 0;\n  border-top: ", " solid\n    ", ";\n"], ["\n  margin: 0;\n  border: 0;\n  border-top: ", " solid\n    ", ";\n"])), function (p) {
  return p.width ? p.width + 'px' : p.theme.borderWidth;
}, function (p) {
  return p.theme.textTertiary;
});

var HorizontalRule = function HorizontalRule(_a) {
  var width = _a.width;
  return React.createElement(Hr, {
    className: "horizontal-rule",
    width: width
  });
};

export default HorizontalRule;
var templateObject_1;